const OTP_LOGIN_ACTION = {
  SET_OTP: "SET_OTP",
  SET_EMAIL: "SET_EMAIL",
  SET_IDENTIFIER: "SET_IDENTIFIER",
  TOGGLE_IS_OTP_SENT: "TOGGLE_IS_OTP_SENT",
  DECREMENT_TIMER: "DECREMENT_TIMER",
  BACK: "BACK",
  OTP_SENT: "OTP_SENT",
  TOGGLE_LOADING: "TOGGLE_LOADING",
  SET_MESSAGE: "SET_MESSAGE",
  SEND_OTP_FAILURE: "SEND_OTP_FAILURE",
  MALFORMED_REQUEST: "MALFORMED_REQUEST",
  RESET: "RESET",
};

const AUTH_ERROR_CODES = {
  EXISTING_CUSTOMER_SIGN_IN_REQUIRED: "EXISTING_CUSTOMER_SIGN_IN_REQUIRED",
};

const OTP_LENGTH = 6;
const RESEND_OTP_TIME = 30;
const OTP_BOX_SEPARATOR = "-";

module.exports = {
  OTP_LOGIN_ACTION,
  AUTH_ERROR_CODES,
  OTP_LENGTH,
  RESEND_OTP_TIME,
  OTP_BOX_SEPARATOR,
};
